import { useGeoIP } from '@hc-frontend/core-ui';
import React from 'react';

export interface WordpressBlogZipcodeFieldProps {
  title: string;
  subtitle: string;
  buttonCta: string;
  popUnderUrl: string;
  popOutUrl?: string;
}

export default function WordpressBlogZipcodeField(
  props: Readonly<WordpressBlogZipcodeFieldProps>,
) {
  const location = useGeoIP();
  const zipCode = location?.zipCode || '';
  const [error, setError] = React.useState<boolean>(zipCode.length !== 5);
  const [inputZipCode, setInputZipCode] = React.useState(zipCode);

  return (
    <div className="my-[20px]">
      <h4 className="font-bold text-2xl mb-[5px]">{props.title}</h4>
      <h5 className="text-xl mb-[10px]">{props.subtitle}</h5>
      <div className="flex">
        <input
          type="number"
          className={`text-lg mr-[10px] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border ${error ? '[border-color:red]' : 'border-gray-300'} rounded-md px-[27px] py-[5px] mr-2`}
          maxLength={5}
          defaultValue={zipCode}
          placeholder="Enter Zip Code"
          onChange={(e) => {
            setError(false);
            setInputZipCode(e.target.value);
          }}
        />
        <button
          className="transition-all bg-secondary-900 hover:bg-secondary-950 rounded-md px-[27px] py-[5px] !text-[white] font-semibold text-lg"
          onClick={() => {
            if (inputZipCode.length !== 5) {
              setError(true);
              return;
            }
            const popUnderUrl = props.popUnderUrl.replace(
              '{{zipCode}}',
              inputZipCode,
            );
            window.open(popUnderUrl, '_self');
            if (props.popOutUrl) {
              const popOutUrl = props.popOutUrl.replace(
                '{{zipCode}}',
                inputZipCode,
              );
              window.open(popOutUrl, '_blank');
            }
          }}
        >
          {props.buttonCta}
        </button>
      </div>
    </div>
  );
}
